<template>
  <div
    class="icontitsub"
    style="--clr-box-back: var(--clr-black-1-1)"
  >
    <div
      v-if="icon"
      :class="icon"
      class="mdi icontitsub_icon gw_loading_text"
      style="font-size: var(--icon-size); height: var(--icon-size); color: var(--icon-color)"
    />
    <div class="icontitsub_text">
      <div
        v-if="title"
        class="icontitsub_title gw_loading_text"
        v-html="title"
      ></div>

      <slot name="subtitle">
        <div
          class="icontitsub_subtitle gw_loading_text"
          v-html="subtitle"
        ></div>
      </slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'IconAndText',
  props: {
    icon: String,
    title: String,
    subtitle: String,
  },
}
</script>

<style lang="scss" scoped>
.icontitsub {
  display: flex;
  flex-direction: column;
  text-align: center;

  --icon-size: 7rem;
  --icon-color: var(--clr-black-3);

  --icon-text-margin: 1rem 0 0 0;

  --icon-title-clr: var(--clr-white-0);
  --icon-title-weight: 700;
  --icon-title-font-size: 1rem;
  --icon-title-align: center;

  --icon-sub-clr: var(--clr-grey-2);
  --icon-sub-weight: 400;
  --icon-sub-font-size: 1rem;
  &_icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &_text {
    display: flex;
    flex-direction: column;
    align-items: var(--icon-title-align);
    justify-content: center;
    margin: var(--icon-text-margin);
    gap: 0.25rem;
  }
  &_title {
    font-weight: var(--icon-title-weight);
    color: var(--icon-title-clr);
    font-size: var(--icon-title-font-size);
  }
  &_subtitle {
    color: var(--icon-sub-clr);
    font-weight: var(--icon-sub-weight);
    font-size: var(--icon-sub-font-size);
  }
}
</style>
